module.exports = [
	{
		"Sl_No": "01",
		"file": "_ARK2882",
		"type": "VIP Suite (Patient Room)",
		"price": "30,000.00"
	},
	{
		"Sl_No": "03",
		"file": "_ARK2885",
		"type": "Deluxe Single",
		"price": "13,000.00"
	},
	{
		"Sl_No": "05",
		"file": "_ARK2984",
		"type": "Standard Single",
		"price": "10,000.00"
	},
	{
		"Sl_No": "07",
		"file": "_ARK2986",
		"type": "Triple Bedded Room",
		"price": "4,000.00"
	},
	{
		"Sl_No": "09",
		"file": "_ARK2987",
		"type": "General Ward",
		"price": "4,200.00"
	},
	{
		"Sl_No": "11",
		"file": "_ARK2991",
		"type": "Oncology Ward",
		"price": "3,500.00"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/cafeteria.json
// module id = 861
// module chunks = 0